import { css } from '@emotion/react';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';

const subTitleCss = (colors: IColors, margin?: number, noMargin?: boolean) => css`
	font-size: 1.8rem;
	font-weight: bold;
	color: ${colors.tx_text_primary};
	margin-bottom: ${`${noMargin ? 0 : margin || 16}px`};
	text-transform: capitalize;
`;

interface Props {
	text: string;
	margin?: number;
	noMargin?: boolean;
}

function SubTitle({ text, margin, noMargin }: Props) {
	const { colors } = useColors();
	return <h2  data-testid="SubTitle-C9CD8A" css={subTitleCss(colors, margin, noMargin)}>{text}</h2>;
}

export default SubTitle;
